module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"no_dit":"Информационное табло не настроено","no_info":"Информация отсутствует","last_data_update":"Время последнего обновления данных:"},"en":{"no_dit":"Information display is not configured","no_info":"No information available","last_data_update":"ime of the last data update:"}}')
  delete Component.options._Ctor
}
